import { useCallback } from "react";
import VerticalLine from "../../assets/icons/vertical_line";
import { useNavigate } from "react-router-dom";
import { APPLICATION_ROUTES } from "../../utils/routes";
import { useTranslation } from "react-i18next";
import RemoveIcon from "../../assets/icons/remove_icon";

const UnreadAnswersModal = ({ setShowModal }) => {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const handleClose = event => {
		event.stopPropagation();
		setShowModal(false);
	};

	const handleViewQuestionsClick = useCallback(
		e => {
			e.stopPropagation();
			setShowModal(false);
			navigate(APPLICATION_ROUTES.PROFILE_QUESTIONS);
		},
		[setShowModal, navigate],
	);

	return (
		<div
			className="fixed top-0 left-0 flex justify-center items-center w-full h-full bg-black/30 cursor-pointer z-[10010]"
			onClick={handleClose}
		>
			<div
				className="relative flex flex-col items-center gap-[40px] max-w-[420px] h-max px-6 py-[26px] rounded-xl bg-bg-page dark:bg-dark-gray-elevated cursor-default z-[10010] max-[440px]:w-[95%] max-[440px]:px-[15px] max-[440px]:py-[15px] max-[440px]:rounded-[15px] [&>h6]:text-text-primary [&>h6]:dark:text-text-dark-gray [&>h6]:text-center [&>h6]:text-lg [&>h6]:font-semibold [&>h6]:leading-[150%] [&>h6]:w-[90%]"
				onMouseDown={e => e.stopPropagation()}
				onClick={e => e.stopPropagation()}
			>
				<h6>{t("unread-answers-modal.title")}</h6>

				<div className="flex justify-center items-center w-full h-[48px] rounded-md border border-primary cursor-pointer">
					<div
						className="flex justify-center items-center w-full h-full text-base font-semibold leading-none tracking-[0.24px] transition-all select-none text-primary hover:text-[17px]"
						onClick={handleViewQuestionsClick}
					>
						{t("unread-answers-modal.view-btn")}
					</div>
				</div>

				<div
					className="absolute top-[6px] right-[6px] flex justify-center items-center h-6 w-[30px] cursor-pointer [&:hover_svg]:scale-[1.12]"
					onClick={handleClose}
				>
					<RemoveIcon
						color="var(--color-text-heading)"
						className="w-5 h-5 transition-all max-[774px]:w-4 max-[774px]:h-4"
					/>
				</div>
			</div>
		</div>
	);
};

export default UnreadAnswersModal;
